import { useLang, useT } from '@/lib/useLang';
import { track } from '@/lib/analytics';

/**
 * La méthode, racontée par l'agence : ce que le client fait (presque rien),
 * puis ce que l'équipe fait. La vidéo qui suit les trois étapes est un motion
 * design en charte (composition Remotion `NeverZeroMethod` / `NeverZeroMethodFR`
 * d'apps/podawaa-promo, réencodée en 1280 px sans piste audio) — pas une
 * capture d'interface, qui faisait passer le site pour un logiciel.
 */
export function HowItWorks() {
  const t = useT();
  const lang = useLang();
  const video = `/video/neverzero-method-${lang}`;

  return (
    <section id="method" className="nz-how">
      <div className="nz-how__panel">
        <div className="nz-eyebrow">{t.howEyebrow}</div>
        <h2 className="nz-h2">{t.howH2}</h2>
        <ol className="nz-how__steps">
          {t.steps.map((step) => (
            <li key={step.n}>
              <div className="nz-step__n">{step.n}</div>
              <div className="nz-step__title">{step.title}</div>
              <div className="nz-step__body">{step.body}</div>
            </li>
          ))}
        </ol>
        <video
          key={lang}
          className="nz-how__video"
          src={`${video}.mp4`}
          poster={`${video}.jpg`}
          aria-label={t.methodVideoLabel}
          controls
          muted
          playsInline
          preload="none"
          onPlay={() => track('method_video_played', { lang })}
        />
      </div>
    </section>
  );
}
